const data = [
  {
    key: 1,
    text: "Клиенты",
    path: "/klient",
  },
  {
    key: 2,
    text: "Поставщики",
    path: "/postavchiki",
  },
  {
    key: 3,
    text: "Моделъ",
    path: "/model",
  },
  {
    key: 4,
    text: "Склад",
    path: "/sklad",
  },
  {
    key: 5,
    text: "Детлъ",
    path: "/detal",
  },
  {
    key: 6,
    text: "Комплект",
    path: "/komplekt",
  },
  {
    key: 7,
    text: "Социалъные сети",
    path: "/satsialniset",
  },
];

export default data;
